import asyncComponent from '../pages/main/asyncComponent'
import changePassword from '../pages/user/changePassword'

// 机构
import ins_login from '../pages/institution/login/index'
import ins_register from '../pages/institution/register/index'

import ins_scanner_merchant from '../pages/institution/scanner/merchant/index'
import ins_scanner_device from '../pages/institution/scanner/device/index'
import ins_scanner_deviceDetail from '../pages/institution/scanner/device/detail'
import ins_scanner_reportList from '../pages/institution/scanner/report/index'
import ins_scanner_setting from '../pages/institution/scanner/setting/index'
import reportDetailScan from '../pages/institution/scanner/report/scan/index'


import ins_silizhu_merchant from '../pages/institution/silizhu/merchant/index'
import ins_silizhu_reportList from '../pages/institution/silizhu/report/list/index'
import ins_silizhu_setting from '../pages/institution/silizhu/setting/index'
import reportDetailSilizhu from '../pages/institution/silizhu/report/detail/index'
import reportDetailSilizhuShare from '../pages/institution/silizhu/report/detail/content'
import ins_silizhu_statistics from '../pages/institution/silizhu/statistics/index'
import ins_export_data from '../pages/institution/export-data/index'

const reportDetailScan_userReport = asyncComponent(import('../pages/institution/scanner/report/scan/userReport/index'));
const reportDetailScan_expertData = asyncComponent(import('../pages/institution/scanner/report/scan/expertData/index'));
const reportDetailScan_leap = asyncComponent(import('../pages/institution/scanner/report/scan/leap/index'));


const routes_ins = [
    {
        path: '/institution/login',
        exact: true,
        component: ins_login,
        authorized: false,
    },
    {
        path: '/institution',
        exact: true,
        component: ins_login,
        authorized: false,
    },
    {
        path: '/institution/register',
        exact: true,
        component: ins_register,
        authorized: false,
    },
]

export const routes_ins_scanner = [
    {
        path: '/institution/merchantList',
        exact: true,
        component: ins_scanner_merchant,
        authorized: true,
    },
    {
        path: '/institution/deviceList',
        exact: true,
        component: ins_scanner_device,
        authorized: true,
    },
    {
        path: '/institution/deviceList/detail/:id',
        exact: true,
        component: ins_scanner_deviceDetail,
        authorized: true,
    },
    {
        path: '/institution/reportList',
        exact: true,
        component: ins_scanner_reportList,
        authorized: true,
    },
    {
        path: '/institution/reportList/:tag',
        exact: true,
        component: ins_scanner_reportList,
        authorized: true,
    },
    {
        path: '/institution/reportList/detail/:id',
        exact: true,
        component: reportDetailScan,
        authorized: true,
    },
    {
        path: '/institution/reportList/userReport/:id',
        exact: true,
        component: reportDetailScan_userReport,
        authorized: true,
    },
    {
        path: '/institution/reportList/expertData/:id',
        exact: true,
        component: reportDetailScan_expertData,
        authorized: true,
    },
    {
        path: '/institution/reportList/leap/:id',
        exact: true,
        component: reportDetailScan_leap,
        authorized: true,
    },
    {
        path: '/institution/setting',
        exact: true,
        component: ins_scanner_setting,
        authorized: true,
    },
    {
        path: '/institution/changePassword',
        exact: true,
        component: changePassword,
        authorized: true,
    }
]

export const routes_ins_silizhu = [
    {
        path: '/institution/merchantList',
        exact: true,
        component: ins_silizhu_merchant,
        authorized: true,
    },
    {
        path: '/institution/reportList',
        exact: true,
        component: ins_silizhu_reportList,
        authorized: true,
    },
    {
        path: '/institution/reportList/:tag',
        exact: true,
        component: ins_silizhu_reportList,
        authorized: true,
    },
    {
        path: '/institution/reportList/detail/:id',
        exact: true,
        component: reportDetailSilizhu,
        authorized: true,
    },
    {
        path: '/institution/setting',
        exact: true,
        component: ins_silizhu_setting,
        authorized: true,
    },
    {
        path: '/institution/changePassword',
        exact: true,
        component: changePassword,
        authorized: true,
    },
    {
        path: '/institution/statistics',
        exact: true,
        component: ins_silizhu_statistics,
        authorized: true,
    },
    {
        path: '/institution/exportData',
        exact: true,
        component: ins_export_data,
        authorized: true,
    }
]


// 商户
import merchant_login from '../pages/merchant/login'
import merchant_register from '../pages/merchant/register'

import merchant_scanner_setting from '../pages/merchant/scanner/setting'
import merchant_scanner_report from '../pages/merchant/scanner/report'
import merchant_scanner_reportDetail from '../pages/merchant/scanner/report/detail'

import merchant_silizhu_setting from '../pages/merchant/silizhu/setting'
import merchant_silizhu_reportList from '../pages/merchant/silizhu/report/list'
import merchant_silizhu_examineeList from '../pages/merchant/silizhu/examinee/list'
import merchant_silizhu_examineeDetail from '../pages/merchant/silizhu/examinee/detail'
import merchant_silizhu_statistics from '../pages/merchant/silizhu/statistics'


const routes_store = [
    {
        path: '/merchant/login',
        exact: true,
        component: merchant_login,
        authorized: false
    },
    {
        path: '/merchant',
        exact: true,
        component: merchant_login,
        authorized: false
    },
    {
        path: '/merchant/register',
        exact: true,
        component: merchant_register,
        authorized: false
    },
]

export const routes_store_scanner = [
    {
        path: '/merchant/reportList',
        exact: true,
        component: merchant_scanner_report,
        authorized: true
    },
    {
        path: '/merchant/reportList/:tag',
        exact: true,
        component: merchant_scanner_report,
        authorized: true
    },
    {
        path: '/merchant/reportList/detail/:id',
        exact: true,
        component: merchant_scanner_reportDetail,
        authorized: true,
    },
    {
        path: '/merchant/reportList/userReport/:id',
        exact: true,
        component: reportDetailScan_userReport,
        authorized: true,
    },
    {
        path: '/merchant/reportList/expertData/:id',
        exact: true,
        component: reportDetailScan_expertData,
        authorized: true,
    },
    {
        path: '/merchant/reportList/leap/:id',
        exact: true,
        component: reportDetailScan_leap,
        authorized: true,
    },
    {
        path: '/merchant/setting',
        exact: true,
        component: merchant_scanner_setting,
        authorized: true,
    },
    {
        path: '/merchant/changePassword',
        exact: true,
        component: changePassword,
        authorized: true,
    }
]

export const routes_store_silizhu = [
    {
        path: '/merchant/examineeList',
        exact: true,
        component: merchant_silizhu_examineeList,
        authorized: true
    },
    {
        path: '/merchant/examineeList/detail/:id',
        exact: true,
        component: merchant_silizhu_examineeDetail,
        authorized: true
    },
    {
        path: '/merchant/examineeList/detail/silizhuReport/:id',
        exact: true,
        component: reportDetailSilizhu,
        authorized: true
    },
    {
        path: '/merchant/reportList',
        exact: true,
        component: merchant_silizhu_reportList,
        authorized: true
    },
    {
        path: '/merchant/reportList/:tag',
        exact: true,
        component: merchant_silizhu_reportList,
        authorized: true
    },
    {
        path: '/merchant/reportList/detail/:id',
        exact: true,
        component: reportDetailSilizhu,
        authorized: true,
    },
    {
        path: '/merchant/setting',
        exact: true,
        component: merchant_silizhu_setting,
        authorized: true,
    },
    {
        path: '/merchant/changePassword',
        exact: true,
        component: changePassword,
        authorized: true,
    },
    {
        path: '/merchant/statistics',
        exact: true,
        component: merchant_silizhu_statistics,
        authorized: true,
    }
]


export default [
    ...routes_ins,
    ...routes_store,
    {
        path: '/silizhuReportDetail/:id',
        exact: true,
        component: reportDetailSilizhuShare,
        authorized: false,
    },
]
